import { createRef, useContext, useEffect, useRef, useState } from 'react'
import ManuBarComponent from '../Components/MenuBarComponent'
import { useTranslation } from 'react-i18next';
import mainImage from '../images/main_image_landing_page.png'
import logoImg from '../images/logo192.png'
import peopleWalking from '../images/people_walking.jpg'
import handsCircleOne from '../images/hands_circle_1.jpg'
import churchPicture from '../images/church.jpg'
import forestPicture from '../images/forest.jpg'
import calendarPicture from '../images/calendar.jpg'
import handsCircle2Picture from '../images/hands_two.jpg'
import { Card } from 'primereact/card';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../Contexts/AuthContext';

function Home() {
    const { t } = useTranslation('landing_page_home');
    const navigate = useNavigate() 
    const {userAuth} = useContext(AuthContext)
    const [isVerified, setIsVerified] = useState(false);
    
    useEffect(()=>{
        userAuth?.user && navigate('/app/user_home')
    },[])
    
    const handleSubmit = async (e) => {
        e.preventDefault();
    };

    const handleRegister = () => {
        navigate('/register')
    }
    const buttonsCss = `text-sm md:text-base 
                px-3 py-2 border-round border-solid
                border-1 white-space-nowrap`

    return (
        <div>
            <ManuBarComponent />
            <div className='flex flex-column gap-4 flex-1 justify-content-start align-items-center pt-8' style={{ 
                backgroundImage: `url(${mainImage})`,
                backgroundSize: 'cover', // Adjust as needed
                backgroundPosition: 'center',
                width: '100%',
                height: '90vh',
            }}>
                <img src={logoImg} alt="freeliefs logo" className='w-8rem md:w-12rem' />
                <div className='text-xl md:text-3xl font-bold'>{t('first_title')}</div>
                <div className='flex flex-wrap justify-content-center gap-2 p-4'>
                    <Button label={t('register')} className={`${buttonsCss} background-primary`} onClick={()=>navigate('/register')} />
                    <Button label={t('login')} className={`${buttonsCss}`} outlined onClick={()=>navigate('/login')} />
                </div>
            </div>
            <div className='flex flex-column md:flex-row mt-4'>
                <div className='flex flex-column justify-content-center gap-2 flex-1 p-4 md:p-8'>
                    <div className='font-bold text-base md:text-xl text-color-primary'>
                        {t('second_title')}
                    </div>
                    <div className='text-xl md:text-3xl'>
                        {t('second_subtitle')}
                    </div>
                    <div className='text-sm md:text-base'>
                        {t('second_description')}
                    </div>
                </div>
                <div className='flex flex-1 p-4 md:p-4'>
                    <img src={peopleWalking} alt="people walking" width={'100%'} />
                </div>
            </div>
            <div className='flex flex-column justify-content-center gap-2 flex-1 p-4 md:p-8 background-accent-one'>
                <div className='font-bold text-base md:text-xl text-color-primary'>
                    {t('third_title')}
                </div>
                <div className='text-xl md:text-3xl'>
                    {t('third_subtitle')}
                </div>
                <div className='flex flex-column md:flex-row gap-2 mt-4'>
                    <Card className='flex-1' title={t('third_boxes.one_title')} subTitle={t('third_boxes.one_subtitle')} header={<img alt='hands on circle' src={handsCircleOne} className='w-full' />}>
                        <Accordion>
                            <AccordionTab header={t('more')}>
                                {t('third_boxes.one_description')}
                            </AccordionTab>
                        </Accordion>
                    </Card>
                    <Card className='flex-1' title={t('third_boxes.two_title')} subTitle={t('third_boxes.two_subtitle')} header={<img alt='church' src={churchPicture} className='w-full' />}>
                        <Accordion>
                            <AccordionTab header={t('more')}>
                                {t('third_boxes.two_description')}
                            </AccordionTab>
                        </Accordion>
                    </Card>
                    <Card className='flex-1' title={t('third_boxes.three_title')} subTitle={t('third_boxes.three_subtitle')} header={<img alt='forest' src={forestPicture} className='w-full' />}>
                        <Accordion>
                            <AccordionTab header={t('more')}>
                                {t('third_boxes.three_description')}
                            </AccordionTab>
                        </Accordion>
                    </Card>
                </div>
            </div>
            <div className='flex flex-column justify-content-center gap-2 flex-1 p-4 md:p-8'>
                <div className='font-bold text-base md:text-xl text-color-primary'>
                    {t('forth_title')}
                </div>
                <div className='text-xl md:text-3xl'>
                    {t('forth_subtitle')}
                </div>
                <div className='flex flex-column md:flex-row gap-2 mt-4'>
                    <Card className='flex-1' title={t('forth_boxes.one_title')} subTitle={t('forth_boxes.one_subtitle')} header={<img alt='hands circle' src={handsCircle2Picture} className='w-full' />}>
                        <Accordion>
                            <AccordionTab header={t('more')}>
                                {t('forth_boxes.one_description')}
                            </AccordionTab>
                        </Accordion>
                    </Card>
                    <Card className='flex-1' title={t('forth_boxes.two_title')} subTitle={t('forth_boxes.two_subtitle')} header={<img alt='calendar' src={calendarPicture} className='w-full' />}>
                        <Accordion>
                            <AccordionTab header={t('more')}>
                                {t('forth_boxes.two_description')}
                            </AccordionTab>
                        </Accordion>
                    </Card>
                </div>
            </div>
            <div className='flex flex-column md:flex-row flex-1 p-4 md:p-8 gap-4 background-primary text-white'>
                <div className='flex flex-column flex-1 justify-content-center gap-2'>
                    <div className='font-bold text-base md:text-xl'>
                        {t('contact_us')}
                    </div>
                    <div className='text-xl md:text-3xl'>
                        {t('contact_subtitle')}
                    </div>
                    <div className='flex flex-column gap-2 mt-4'>
                        <form onSubmit={handleSubmit}>
                            <div className='flex flex-column gap-2'>
                                <div className='flex flex-column gap-1'>
                                    <span>{t('form_name')}</span>
                                    <InputText />
                                </div>
                                <div className='flex flex-column gap-1'>
                                    <span>{t('form_email')}</span>
                                    <InputText />
                                </div>
                                <div className='flex flex-column gap-1'>
                                    <span>{t('form_phone')}</span>
                                    <InputText />
                                </div>
                                <div className='flex flex-column gap-1'>
                                    <span>{t('form_message')}</span>
                                    <InputTextarea />
                                </div>
                                <div className='flex gap-1'>
                                    <Checkbox /><span>{t('form_check_message')}</span>
                                </div>
                                <ReCAPTCHA
                                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                    onChange={(token) => token && setIsVerified(true)}
                                />
                                <Button type='submit' disabled={!isVerified} className='background-secondary' label={t('form_submit_button')} />
                            </div>
                        </form>
                    </div>
                </div>
                <div className='flex flex-1 justify-content-center'>
                    <div className='flex flex-column gap-4'>
                        <div className='text-4xl'>Freeliefs</div>
                        <div>
                            <div>Email</div>
                            <div>info@freeliefs.com</div>
                        </div>
                        <Button label={t('register')} className='border-2 border-0 background-secondary' onClick={handleRegister} />                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home